import { getSettlements } from "@/services/settlements.service";
import { useQuery } from "@tanstack/react-query";

export const useSettlements = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "settlements",
    params.page,
    params.size,
    params.status,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getSettlements(params),
    enabled,
    ...options,
  });
};
